// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05bb3f09","453":"5c297afa","667":"6cb8ed3d","977":"03f1052f"}[chunkId] + ".chunk.js";
};